module.exports = new __parcel__URL__("battlepass_inactive_button.238a03ab.png").toString();